module.exports = __webpack_public_path__ + "assets/img/drip-logo-white-tagline-e2e.9ec2565b.svg";